module.exports = __webpack_public_path__ + "624c1255/img/32000000-3.db4cfb35.png";